// extracted by mini-css-extract-plugin
export default {"badge":"PaymentMethodBadge_badge__b-7Aq"};